//import create from 'zustand'
import { Tag, Tooltip, Table, Alert, Card, Input, Button, Space } from 'antd';
import React, { Component, useState, useEffect, useRef } from 'react';
import { isMobile } from "react-device-detect"
import { v4 as uuidv4 } from 'uuid';
import { Typography } from 'antd';
const { Paragraph, } = Typography;

export const DEFAULT_PAGE = 25;

export const market_filters = [
  { text: "KS", value: "0" },
  { text: "KQ", value: "1" },
];
export const market_redefine = [
  { text: "S"},
  { text: "Q"},
];

export const state_filters = [
  { text: "매수", value: "0" },
  { text: "매도", value: "1" },
];

export const gubun_filters = [
  { text: "대기", value: "0" },
  { text: "매수", value: "1" },
  { text: "보유", value: "2" },
  { text: "매도", value: "3" },
  { text: "급매", value: "4" },
  { text: "청산", value: "5" },
  { text: "손절", value: "6" },
];

/*
const useStore = create (() => ({
  navidx: 0,
}))
*/

export function changeColor(text, gubun) {
  //console.log(text, gubun);
  var val = parseFloat(text)
  if (val > 0) {
    return <span style={{ color: 'red' }}>{text}</span>
  }
  else if (val < 0) {
    return <span style={{ color: 'blue' }}>{text}</span>
  }
  else {
    return <span >{text}</span>
  }
}

export function renderJongMok(record) {
  return <div>
    <a href={`https://finance.naver.com/item/main.nhn?code=` + record.z_code} target='_blank' rel='noopener noreferrer nofollow'>{record.z_name}</a>&nbsp;({record.z_market})
    </div>
}

export function renderCode(code) {
  if (isMobile) {
    return <a href={`https://m.stock.naver.com/fchart/domestic/stock/` + code} target='_blank' rel='noopener noreferrer nofollow'>{code}</a>
  } else {
    return <a href={`https://finance.daum.net/chart/A` + code} target='_blank' rel='noopener noreferrer nofollow'>{code}</a>
  }
}

export function makeTableTitle(title, val) {
  // var star;
  // if (val === 1) star = "⭐"
  // else if (val === 2) star = "⭐⭐"
  // else if (val === 3) star = "⭐⭐⭐"
  // else if (val === 4) star = "⭐⭐⭐⭐"
  // else star = ""
  // return title + "  " + star;
  return title;
};

export function makeESearchTableText(title, val) {

  let arr = [];

  if (val.indexOf("MACD저항(일)") != -1) {
    arr.push({ id: "M1", desc: "MACD저항(일)", color: "#2db7f5" });
  }
  if (val.indexOf("MACD저항(주)") != -1) {
    arr.push({ id: "M5", desc: "MACD저항(주)", color: "#2db7f5" });
  }
  if (val.indexOf("STOC과매도(일)") != -1) {
    arr.push({ id: "S1", desc: "STOC과매도(일)", color: "#FF8C00" });
  }
  if (val.indexOf("STOC과매도(주)") != -1) {
    arr.push({ id: "S5", desc: "STOC과매도(주)", color: "#FF8C00" });
  }
  if (val.indexOf("장기추세(210)") != -1) {
    arr.push({ id: "추세", desc: "장기추세(210)", color: "#87d068" });
  }
  if (val.indexOf("순이익흑전") != -1) {
    arr.push({ id: "흑전", desc: "순이익흑전", color: "#87d068" });
  }
  if (val.indexOf("성장주") != -1) {
    arr.push({ id: "성장", desc: "성장주", color: "#87d068" });
  }
  if (val.indexOf("평균거래급증") != -1) {
    arr.push({ id: "거래", desc: "평균거래급증", color: "#ff1493" });
  }
  if (val.indexOf("볼린저밴드하단근접") != -1) {
    arr.push({ id: "B.B", desc: "볼린저밴드하단근접", color: "#ff1493" });
  }

  return arr.map(res => (
    <Tooltip placement="topLeft" mouseLeaveDelay="0.2" trigger="click|hover" title={res.desc}>
      <Tag color={res.color} style={{ margin: 1, fontSize: '5px', color: '#fff' }} key={res.id}> {res.id} </Tag>
    </Tooltip>
  ))
};

export function makeCustomRedColor(text) {
  var result;
  var code = parseInt(text);
  if (code <= 0) {
    code = code * -1;
    code = 255 - (code * 2);
    var val = code.toString(16);
    result = '#' + val + val + 'ff';
  }
  else {
    code = 255 - (code * 2);
    var val = code.toString(16);
    result = '#ff' + val + val;
  }
  return result;
}

// 현재 시간을 가져오는 함수
function getCurrentUnixTime() {
  return Math.floor(Date.now() / 1000); // Date.now() 는 밀리초(ms) 단위로 반환하므로 1000으로 나누어 초 단위로 변환
}

// UNIX 시간을 일(day)로 변환하는 함수
function unixTimeToDays(unixTime) {
  return Math.floor(unixTime / (60 * 60 * 24)); // 1일은 86400초 이므로 초 단위로 된 UNIX 시간을 1일로 나누어 일(day) 단위로 변환
}

// 현재 시간에서 특정 UNIX 시간을 빼서 경과 일수를 계산하는 함수
function calculateElapsedDays(specificUnixTime) {
  const currentUnixTime = getCurrentUnixTime();
  const elapsedSeconds = currentUnixTime - specificUnixTime;
  const elapsedDays = unixTimeToDays(elapsedSeconds);
  return elapsedDays;
}

export function UnixTimeToStringDateIncludePassDay(unixTime) {
  var strdate = UnixTimeToStringDate(unixTime);

  if(strdate.length > 0) {
    const timeZoneOffsetMinutes = 540;
    const specificDateTime = new Date(unixTime + timeZoneOffsetMinutes);
  
    // 현재 시간의 Date 객체 생성
    const currentDate = new Date();

    // 특정일로부터 경과한 시간(밀리초) 계산
    const elapsedMilliseconds = currentDate - specificDateTime;
    // 경과한 시간을 일(day) 단위로 변환
    const elapsedDays = elapsedMilliseconds / (1000 * 60 * 60 * 24);
    // 소수점 이하 버림하여 정수값으로 반환
    return strdate + " (+" + Math.floor(elapsedDays) + "d)";
  }
  return strdate;
}

export function UnixTimeToStringDate(unixTime) {
  if (unixTime === null) { 
    return '';
  }

  const timeZoneOffsetMinutes = 540;
  const dateObj = new Date(unixTime + timeZoneOffsetMinutes);

  // 날짜와 시간 값을 문자열로 변환
  const year = dateObj.getFullYear();
  const str_year = year.toString().slice(2, 4);
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const date = String(dateObj.getDate()).padStart(2, '0');
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const seconds = String(dateObj.getSeconds()).padStart(2, '0');

  // 문자열을 결합하여 "y-m-d" 형태로 표시
  const dateString = `${str_year}/${month}/${date}`;
  return dateString;

}

export function UnixTimeToStringDateTime(unixTime) {
  if (unixTime === null) { 
    return '';
  }

  const dateObj = new Date(unixTime);

  // 날짜 및 시간을 원하는 형식으로 포맷팅
  const year = dateObj.getUTCFullYear().toString().substr(-2);
  const mon = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = dateObj.getUTCDate().toString().padStart(2, '0');
  const hour = dateObj.getUTCHours().toString().padStart(2, '0');
  const min = dateObj.getUTCMinutes().toString().padStart(2, '0');

  const formattedDate = `${year}/${mon}/${day} ${hour}:${min}`;

  return formattedDate;
}

/// 유니크 키 값을 반환
export const getUniqueKey = () => {
  var k = uuidv4();
  //console.log("key : ", k);
  return k;
}

/// 이미지 경로 반환
export function ImageDisplay({ props }) {
  const imagePath = process.env.PUBLIC_URL + '/img/ccode/' + props.z_country + '.png';
  return <img src={imagePath} />;
}

// 주어진 날짜 문자열과 현재 시간 사이의 남은 일수 계산 함수
export function calculateRemainingDays(targetDateString) {
  const targetDate = new Date(targetDateString);
  const currentDate = new Date();

  // 시간 차이 계산 (밀리초 단위)
  const timeDifference = targetDate - currentDate;

  // 밀리초를 일 단위로 변환
  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const remainingDays = Math.ceil(timeDifference / millisecondsPerDay);

  if (remainingDays === 0) {
    return <span style={{ color: '#e41b17' }}>Today !</span>
  } else if (remainingDays < 0) {
    return "- ";
  } else if (remainingDays <= 10) {
    const sRemain = "" + remainingDays + " days";
    return <span style={{ color: '#ff9800' }}> {sRemain} </span>
  }
  else {
    return "" + remainingDays + " days";
  }
}

export function GetPosterImgPath(startDt, no) {
  const dateObj = new Date(startDt);

  // 날짜 및 시간을 원하는 형식으로 포맷팅
  const year = dateObj.getUTCFullYear().toString();
  const mon = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = dateObj.getUTCDate().toString().padStart(2, '0');
  const hour = dateObj.getUTCHours().toString().padStart(2, '0');
  const min = dateObj.getUTCMinutes().toString().padStart(2, '0');

  const dateString = `${year}${mon}${day}`;
  const imgpath = "/img/poster/" + dateString + '-' + no + ".png";
  //console.log(imgpath);

  return imgpath;
}


export function formatDateTime(inputDateTime) {
  if(!inputDateTime) return '';
  
  // 입력된 날짜 문자열을 Date 객체로 변환
  var dateObj = new Date(
      inputDateTime.substr(0, 4),  // 년도
      parseInt(inputDateTime.substr(4, 2)) - 1,  // 월 (0부터 시작하므로 -1)
      inputDateTime.substr(6, 2),  // 일
      inputDateTime.substr(9, 2),  // 시간
      inputDateTime.substr(11, 2),  // 분
      inputDateTime.substr(13, 2)  // 초
  );

  // Date 객체를 포맷에 맞게 문자열로 변환
  var formattedDateTime = `${dateObj.getFullYear().toString().substr(2, 2)}` +
                          `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}` +
                          `${dateObj.getDate().toString().padStart(2, '0')} ` +
                          `${dateObj.getHours().toString().padStart(2, '0')}` +
                          `${dateObj.getMinutes().toString().padStart(2, '0')}` +
                          `${dateObj.getSeconds().toString().padStart(2, '0')}`;

  return formattedDateTime;
}

// 테스트
//var inputDateTime = "20231205 091000";
//var formattedDateTime = formatDateTime(inputDateTime);
//console.log(formattedDateTime);

export function calcRemainPercentage(curprice, stopprice) {
  if(curprice != null && stopprice != 0) {
    const remainingPercentage = ((stopprice - curprice) / stopprice) * 100;
    // 남은 비율이 음수인 경우 양수로 변환하여 표현
    //const remainingPercentageFormatted = remainingPercentage < 0 ? -remainingPercentage : remainingPercentage;
    const sign = remainingPercentage < 0 ? "+" : "-";
    return curprice + " (" + sign + remainingPercentage.toFixed(2) + "%)"; // 결과 출력;
  }
}